import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLFormElement> {
  static values = { message: String }
  declare readonly messageValue: string

  connect(): void {
    this.element.addEventListener("input", this.validate)
  }

  disconnect(): void {
    this.element.removeEventListener("input", this.validate)
  }

  private validate = (): void => {
    const password = this.element.querySelector<HTMLInputElement>('[name="user[password]"]')
    const confirmation = this.element.querySelector<HTMLInputElement>('[name="user[password_confirmation]"]')
    if (!password || !confirmation) return
    confirmation.setCustomValidity(
      confirmation.value && password.value !== confirmation.value ? this.messageValue : ""
    )
  }
}
